/* COMMENTING ALL THE OLD CODE FOR A NEW VERSION 

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);
      }

// CART BEHAVIOUR CHANGE EXPERIMENT - Kishore      
//      onSubmitHandler(evt) {
//        evt.preventDefault();
//
//        const submitButton = this.querySelector('[type="submit"]');
//
//        submitButton.setAttribute("disabled", true);
//        submitButton.classList.add("loading");
//        // Get Cart API
//        let config = fetchConfig("javascript");
//        config.headers["X-Requested-With"] = "XMLHttpRequest";
//        delete config.headers["Content-Type"];
//
//        let formData = new FormData(this.form);
//        if (this.cartNotification) {
//          formData.append(
//            "sections",
//            this.cartNotification
//              .getSectionsToRender()
//              .map((section) => section.id)
//          );
//          this.cartNotification.setActiveElement(document.activeElement);
//        }
//
//        if (this.cartItems) {
//          formData.append(
//            "sections",
//            this.cartItems
//              .getSectionsToRender()
//              .map((section) => section.section)
//          );
//        }
//
//        formData.append("sections_url", window.location.pathname);
//        config.body = formData;
//
//        fetch(`${routes.cart_add_url}`, config)
//          .then((response) => response.json())
//          .then((parsedState) => {
//            if (parsedState.status) {
//              this.handleErrorMessage(parsedState.description);
//              return;
//            }
//            if (this.cartNotification) {
//              this.cartNotification.renderContents(parsedState);
//            }
//
//            if (this.cartItems) {
//              this.cartItems.renderContents(parsedState);
//            }
//
//            document.querySelector(".product-form__error-message-wrapper")?.classList.add("no-js-inline");
//          })
//          .catch((e) => {
//           console.error(e);
//          })
//          .finally(() => {
//            submitButton.classList.remove("loading");
//            submitButton.removeAttribute("disabled");
//            this.quickViewWarpper?.classList.remove("show__modal");
//            document.body.classList.remove("overflow-hidden");
//          });
//      }

// NEW SECTION BEGIN
      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");

        // Open the mini cart immediately with a loading bar (not inside quick view)
        const inQuickView = !!this.closest("#quickViewWrapper");
        const drawer = this.cartNotification?.notification;
        if (this.cartNotification && !inQuickView) {
          this.cartNotification.open();
          drawer?.classList.add("loading-bar");
        }

        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);
        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
          formData.append(
            "sections",
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              if (!inQuickView) this.cartNotification?.close();
              this.handleErrorMessage(parsedState.description);
              return;
            }
            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }

            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }

            document.querySelector(".product-form__error-message-wrapper")?.classList.add("no-js-inline");
          })
          .catch((e) => {
            console.error(e);
            if (!inQuickView) this.cartNotification?.close();
          })
          .finally(() => {
            drawer?.classList.remove("loading-bar");
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }
// NEW SECTION END

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}

END COMMENT OF OLD CODE */

// Switch: false = old behaviour (drawer opens only after the server replies)
const KJ_OPEN_DRAWER_FIRST = true;

// Shared toast (same .kj-toast style as the cards)
window.kjToast = window.kjToast || function (msg) {
  document.querySelectorAll(".kj-toast").forEach((n) => n.remove());
  const t = document.createElement("div");
  t.className = "kj-toast";
  t.setAttribute("role", "status");
  t.textContent = msg;
  document.body.appendChild(t);
  setTimeout(() => t.remove(), 3500);
};

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
      }

      // First non-empty text node inside the button (the "Add to cart" label)
      getLabelNode(button) {
        const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (node.nodeValue.trim()) return node;
        }
        return null;
      }
      
      /*
      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.hasAttribute("disabled")) return;

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        this.clearFallbackError();

        // Immediate feedback in the button
        const labelNode = window.kjCardStepper ? this.getLabelNode(submitButton) : null;
        const prevText = labelNode ? labelNode.nodeValue : "";
        const baseLabel = labelNode
          ? labelNode.nodeValue.replace(/\s*\(\d+\)\s*$/, "").trim()
          : "";
        if (labelNode) labelNode.nodeValue = "Adding...";

        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);
        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
          formData.append(
            "sections",
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        let added = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              // e.g. 422 "maximum quantity already in your cart": no drawer, show the message
              if (labelNode) labelNode.nodeValue = prevText;
              this.handleErrorMessage(
                parsedState.description || parsedState.message
              );
              return;
            }

            added = true;
            if (labelNode) {
              labelNode.nodeValue = parsedState.quantity
                ? `${baseLabel} (${parsedState.quantity})`
                : baseLabel;
            }

            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }

            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }

            document
              .querySelector(".product-form__error-message-wrapper")
              ?.classList.add("no-js-inline");
          })
          .catch((e) => {
            console.error(e);
            if (labelNode) labelNode.nodeValue = prevText;
            this.handleErrorMessage("Something went wrong. Please try again.");
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            // Only close quick view after a successful add, so errors stay visible
            if (added) {
              this.quickViewWarpper?.classList.remove("show__modal");
              document.body.classList.remove("overflow-hidden");
            }
          });
      }

      */

      onSubmitHandler(evt) {
  evt.preventDefault();

  const submitButton = this.querySelector('[type="submit"]');
  if (submitButton.hasAttribute("disabled")) return;

  submitButton.setAttribute("disabled", true);
  submitButton.classList.add("loading");
  this.clearFallbackError();

  // Open the drawer immediately (not inside quick view, which overlays it)
  const inQuickView = !!this.closest("#quickViewWrapper");
  const drawer = this.cartNotification?.notification;
  const openedEarly = KJ_OPEN_DRAWER_FIRST && !!this.cartNotification && !inQuickView;
  if (openedEarly) {
    this.cartNotification.open();
    drawer?.classList.add("loading-bar");
  }

  const labelNode = window.kjCardStepper ? this.getLabelNode(submitButton) : null;
  const prevText = labelNode ? labelNode.nodeValue : "";
  const baseLabel = labelNode
    ? labelNode.nodeValue.replace(/\s*\(\d+\)\s*$/, "").trim()
    : "";
  if (labelNode) labelNode.nodeValue = "Adding...";

  const fail = (message) => {
    if (labelNode) labelNode.nodeValue = prevText;
    if (openedEarly) this.cartNotification.close();
    if (inQuickView) this.handleErrorMessage(message);
    else window.kjToast(message);
  };

  let config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  let formData = new FormData(this.form);
  if (this.cartNotification) {
    formData.append(
      "sections",
      this.cartNotification.getSectionsToRender().map((s) => s.id)
    );
    this.cartNotification.setActiveElement(document.activeElement);
  }
  if (this.cartItems) {
    formData.append(
      "sections",
      this.cartItems.getSectionsToRender().map((s) => s.section)
    );
  }
  formData.append("sections_url", window.location.pathname);
  config.body = formData;

  let added = false;

  fetch(`${routes.cart_add_url}`, config)
    .then(async (response) => {
      let data = null;
      try { data = await response.json(); } catch (e) {}
      return { response, data };
    })
    .then(({ response, data }) => {
      if (!response.ok || !data || data.status) {
        let msg = "Could not add to cart. Please try again.";
        if (response.status === 429) msg = "Please slow down and try again in a moment.";
        else if (data && typeof (data.description || data.message) === "string")
          msg = data.description || data.message;
        fail(msg);
        return;
      }

      added = true;
      if (labelNode) {
        labelNode.nodeValue = data.quantity
          ? `${baseLabel} (${data.quantity})`
          : baseLabel;
      }
      this.cartNotification?.renderContents(data);
      this.cartItems?.renderContents(data);
      document
        .querySelector(".product-form__error-message-wrapper")
        ?.classList.add("no-js-inline");
    })
    .catch((e) => {
      console.error(e);
      fail(
        navigator.onLine === false
          ? "You appear to be offline. Check your connection and try again."
          : "Something went wrong. Please try again."
      );
    })
    .finally(() => {
      drawer?.classList.remove("loading-bar");
      submitButton.classList.remove("loading");
      submitButton.removeAttribute("disabled");
      if (added) {
        this.quickViewWarpper?.classList.remove("show__modal");
        document.body.classList.remove("overflow-hidden");
      }
    });
}
      clearFallbackError() {
        clearTimeout(this.errorTimer);
        this.querySelector(".product-form__fallback-error")?.remove();
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper?.querySelector(
            ".product-form__error-message"
          );

        if (this.errorMessageWrapper && this.errorMessage) {
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
            this.errorMessageWrapper.classList.remove("no-js-inline");
          }
          return;
        }

        // Fallback for forms without an error area (cards, quick add)
        this.clearFallbackError();
        if (!errorMessage) return;
        const el = document.createElement("div");
        el.className = "product-form__fallback-error";
        el.setAttribute("role", "alert");
        el.style.cssText =
          "color:#b3261e;font-size:13px;line-height:1.4;margin-top:8px;text-align:center;";
        el.textContent = errorMessage;
        this.querySelector('[type="submit"]').insertAdjacentElement("afterend", el);
        this.errorTimer = setTimeout(() => el.remove(), 6000);
      }
    }
  );
}